import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.assign.js";
export function transformDetailData(res) {
  var _ref = res || {},
    data = _ref.data;
  var _ref2 = data || {},
    baseProjectVO = _ref2.baseProjectVO,
    projectParticularsVO = _ref2.projectParticularsVO,
    shopVO = _ref2.shopVO,
    saleRemindVO = _ref2.saleRemindVO,
    promotionVO = _ref2.promotionVO,
    displayVO = _ref2.displayVO,
    contentVO = _ref2.contentVO,
    billBoardVO = _ref2.billBoardVO,
    thirdProjectVO = _ref2.thirdProjectVO,
    priceVO = _ref2.priceVO,
    projectHandleVO = _ref2.projectHandleVO,
    prefillVO = _ref2.prefillVO,
    wantToSeeVO = _ref2.wantToSeeVO,
    priorityActivityCardVO = _ref2.priorityActivityCardVO,
    privilegeActivityVo = _ref2.privilegeActivityVo,
    kingHonorFlag = _ref2.kingHonorFlag,
    externalActivity = _ref2.externalActivity,
    downgradeModuleList = _ref2.downgradeModuleList;
  var _ref3 = baseProjectVO || {},
    saleChannelList = _ref3.saleChannelList,
    saleStatus = _ref3.saleStatus;
  var _ref4 = projectParticularsVO || {},
    highlightInfo = _ref4.highlightInfo,
    photoStageInfo = _ref4.photoStageInfo,
    videoInfo = _ref4.videoInfo,
    songVO = _ref4.song,
    detail = _ref4.detail,
    videoNum = _ref4.videoNum,
    photoNum = _ref4.photoNum;
  var _ref5 = highlightInfo || {},
    brightPointList = _ref5.brightPointList,
    brightPointName = _ref5.brightPointName;
  var _ref6 = photoStageInfo || {},
    photoStageList = _ref6.photoStageList,
    videoStageName = _ref6.videoStageName;
  var _ref7 = videoInfo || {},
    videoList = _ref7.videoList;
  var _ref8 = saleRemindVO || {},
    needRemindPrice = _ref8.needRemindPrice,
    ticketPriceList = _ref8.ticketPriceList,
    projectReserveVO = _ref8.projectReserveVO;
  // const { num } = projectReserveVO || {};

  var _ref9 = promotionVO || {},
    businessBatchList = _ref9.businessBatchList,
    discountList = _ref9.discountList,
    setTicketList = _ref9.setTicketList,
    projectGiftVO = _ref9.projectGiftVO,
    preferenceList = _ref9.preferenceList,
    thirdCouponInfoVO = _ref9.thirdCouponInfoVO,
    groupBuyVOList = _ref9.groupBuyVOList,
    promotionDetails = _ref9.promotionDetails,
    promotionFloorTitles = _ref9.promotionFloorTitles;
  var _ref10 = thirdCouponInfoVO || {},
    supportWenhui = _ref10.supportWenhui,
    wenhuiActivityUrl = _ref10.wenhuiActivityUrl;
  var promotional = {
    businessBatchList: businessBatchList,
    setTicketList: setTicketList,
    preferenceList: preferenceList,
    projectGiftVO: projectGiftVO,
    discountList: discountList,
    supportWenhui: supportWenhui,
    wenhuiActivityUrl: wenhuiActivityUrl,
    promotionDetails: promotionDetails,
    groupBuyVOList: groupBuyVOList,
    promotionFloorTitles: promotionFloorTitles
  };
  var _ref11 = thirdProjectVO || {},
    dyProjectId = _ref11.dyProjectId;
  var kugouMusicList = [];
  var kugoubaseInfo = {};
  if (songVO && songVO.list && Array.isArray(songVO.list)) {
    // 只显示列表大小为3的情况
    if (songVO.list && songVO.list.length >= 3) {
      kugouMusicList = songVO.list.slice(0, 3);
      var authorName = songVO.authorName,
        authorAvatar = songVO.authorAvatar,
        kugouSongsTitle = songVO.kugouSongsTitle;
      kugoubaseInfo = {
        authorName: authorName,
        authorAvatar: authorAvatar,
        kugouSongsTitle: kugouSongsTitle
      };
    }
  }
  var _ref12 = prefillVO || {},
    prefillCompleted = _ref12.prefillCompleted,
    needPreInput = _ref12.needPrefill;
  var lastData = Object.assign({}, baseProjectVO, shopVO, contentVO, priceVO, wantToSeeVO, {
    projectHandleVO: projectHandleVO,
    brightPointList: brightPointList,
    photoStageList: photoStageList,
    videoList: videoList,
    videoStageName: videoStageName,
    saleRemindVO: saleRemindVO,
    detail: detail,
    needRemindPrice: needRemindPrice,
    ticketPriceList: ticketPriceList,
    projectReserveVO: projectReserveVO,
    promotional: promotional
  }, displayVO, {
    billBoardVO: billBoardVO,
    dyProjectId: dyProjectId,
    // relievedTagVO, // 安心看
    prefillCompleted: prefillCompleted,
    needPreInput: needPreInput,
    brightName: brightPointName,
    songVO: {
      kugouMusicList: kugouMusicList,
      kugoubaseInfo: kugoubaseInfo
    },
    saleChannelList: saleChannelList,
    videoNum: videoNum,
    photoNum: photoNum,
    // reserveNum: num,
    // buyInstructionType: 1
    kingHonorFlag: kingHonorFlag,
    externalActivity: externalActivity,
    priorityActivityCardVO: priorityActivityCardVO,
    privilegeActivityVo: privilegeActivityVo,
    saleStatus: saleStatus,
    downgradeModuleList: downgradeModuleList
  });
  return Object.assign({}, res, {
    data: lastData
  });
}